import { useState, useMemo, useRef } from "react"
import { useRequest } from "ahooks";
import { Card, Button, message } from "antd";
import { EditForm } from "./../../../components/editForm";
import { Table, DEFAULT_PAGE_DATA } from "./../../../components/table";
import { DEFAULT_QUERY_DATA, generateQueryFormConfig, generateTableColumns } from "./config";
import { MemberServer, CommonServer } from "./../../../server";
import { Operation } from "./operation";
import { Amount } from "./amount";
import { SafeBalance } from "./safeBalance";
import { langCommon } from "../../../locales";

const server = MemberServer.User

export const User = () => {
    const operationRef: any = useRef();
    const amountRef: any = useRef();
    const safeBalanceRef: any = useRef()

    const [loading, setLoading] = useState<boolean>(false);
    const [queryData, setQueryData] = useState<any>({ ...DEFAULT_QUERY_DATA });
    const [tableData, setTableData] = useState<any[]>([]);
    const [pageData, setPageData] = useState<any>({ ...DEFAULT_PAGE_DATA });
    const [levelOptions, setLevelOptions] = useState<any>([]);


    //获取表格数据
    const { run, refresh } = useRequest(server.list, {
        defaultParams: [{ ...pageData }],
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setTableData([]);
            setPageData({ ...pageData, Total: 0 });
        },
        onSuccess: (res: any) => {
            const { Total, List, Page, PageSize } = res;
            setTableData(List);
            setPageData({ Page, PageSize, Total });
        }
    });

    useRequest(CommonServer.Level.list, {
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onSuccess: (res: any) => {
            setLevelOptions(res?.map((item: any) => ({ id: item.Id, name: item.Name })) || []);
        }
    });

    const { run: deleteData } = useRequest(server.delete, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onSuccess: () => {
            refresh();
            message.success(langCommon?.deleteSuccess);
        }
    });
    // 重置验证码
    const { run: resetCode } = useRequest(server.resetCode, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => { },
        onSuccess: () => {
            refresh();
            message.success('重置成功！')
        }
    });
    const getQueryFormConfig = useMemo(() => {
        return generateQueryFormConfig({});
    }, []);

    const getTableColumns = useMemo(() => {
        return generateTableColumns({ deleteData, operationRef, loading, setLoading, refresh, amountRef, resetCode, safeBalanceRef });
    }, [deleteData, operationRef, loading, setLoading, refresh, amountRef, resetCode, safeBalanceRef]);

    return (
        <div>

            <Card>
                <div className="flex space-between">
                    <EditForm
                        componentId="user-query-form"
                        loading={loading}
                        formAttrsProps={{
                            layout: 'inline',
                        }}
                        formData={queryData}
                        onDataChange={setQueryData}
                        formConfig={getQueryFormConfig}
                        onQuery={() => {
                            run({ ...DEFAULT_PAGE_DATA, ...queryData });
                        }}
                        onReset={() => {
                            setQueryData({ ...DEFAULT_QUERY_DATA });
                            run({ ...DEFAULT_QUERY_DATA, ...DEFAULT_PAGE_DATA });
                        }}
                    />
                    <Button className="ml10" type="primary" onClick={() => operationRef.current?.changeVisible(true, 'create')}>{langCommon?.create}</Button>
                </div>
            </Card>
            <Card className="mt20">
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    rowKey="Id"
                    scroll={{
                        x: 'max-content'
                    }}
                    page={pageData}
                    onPageChange={(Page: number, PageSize: number) => {
                        const currentPage = { ...pageData, Page, PageSize };
                        run({ ...currentPage, ...queryData });
                    }}
                />
            </Card >
            <Operation ref={operationRef} levelOptions={levelOptions} onSuccess={refresh} />
            <Amount ref={amountRef} onSuccess={refresh} />
            <SafeBalance ref={safeBalanceRef} />
        </div>
    );
}